import { Badge, formatDate, formatNumber } from "@";

// TanStack column defs for the donor's recent-donations table (Show page)
export const donorColumns = [
  {
    id: "orderId",
    header: "رقم العملية",
    cell: ({ row }) => (
      <span className="font-mono tabular-nums">{row.original.orderId}</span>
    ),
  },
  {
    id: "projectTitle",
    header: "اسم المشروع",
    accessorFn: ({ projectTitle }) => projectTitle,
  },
  {
    id: "donationAmount",
    header: "مبلغ التبرع",
    cell: ({ row }) => (
      <span className="font-semibold tabular-nums tracking-tight text-purple-900 dark:text-purple-300">
        {formatNumber(row.original.donationAmount)}
      </span>
    ),
  },
  {
    id: "createdOn",
    header: "التاريخ",
    cell: ({ row }) => (
      <span className="tabular-nums">{formatDate(row.original.createdOn)}</span>
    ),
  },
  {
    id: "paymentType",
    header: "وسيلة التبرع",
    cell: ({ row }) => (
      <Badge
        title={row.original.paymentType === 0 ? "بطاقة" : "تحويل بنكي"}
        color={row.original.paymentType === 0 ? "default" : "dark"}
      />
    ),
  },
  {
    id: "isPaid",
    header: "حالة التبرع",
    cell: ({ row }) => (
      <Badge
        title={row.original.isPaid ? "مدفوعة" : "غير مدفوعة"}
        color={row.original.isPaid ? "green" : "red"}
      />
    ),
  },
];

// TanStack column defs for the donors-list table (Index page)
export const donorsColumns = [
  {
    id: "displayName",
    header: "اسم المتبرع",
    cell: ({ row }) => {
      const name = row.original.displayName;
      const initials = name
        ?.split(" ")
        .filter(Boolean)
        .slice(0, 2)
        .map((s) => s.charAt(0))
        .join("")
        .toUpperCase();
      return (
        <div className="flex items-center gap-2.5">
          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-gradient-to-br from-purple-800 to-purple-950 text-[11px] font-bold uppercase text-white shadow-sm shadow-purple-900/20 ring-1 ring-purple-900/10 dark:from-purple-600 dark:to-purple-800">
            {initials || "؟"}
          </span>
          <span className="truncate font-medium tracking-tight text-gray-900 dark:text-gray-100">
            {name?.length > 50 ? name.slice(0, 50) + "..." : name}
          </span>
        </div>
      );
    },
  },
  {
    id: "phone",
    header: "رقم الجوال",
    cell: ({ row }) => (
      <span
        dir="ltr"
        className="font-mono tabular-nums text-gray-700 dark:text-gray-300"
      >
        {row.original.phone}
      </span>
    ),
  },
  {
    id: "email",
    header: "البريد الالكتروني",
    cell: ({ row }) => (
      <span className="truncate text-gray-600 dark:text-gray-400">
        {row.original.email}
      </span>
    ),
  },
  {
    id: "isActive",
    header: "الحالة",
    cell: ({ row }) => (
      <Badge
        title={row.original.isActive ? "مفعل" : "غير مفعل"}
        color={row.original.isActive ? "green" : "red"}
      />
    ),
  },
];
